import React from "react";

interface SpacingProps {
  children?: React.ReactNode;
  width?: number;
  height?: number;
}

/**
 * Creates a visual whitespace with given width or height
 */
export function Spacing(props: SpacingProps) {
  const { children, width, height } = props;

  return <div style={{ width, height }}>{children}</div>;
}
